import { ACTIVEDRAWING } from "../../actions/portal/";

export default function(state = false, action){
  switch (action.type) {
    case ACTIVEDRAWING:
    return action.payload;
    default:
  }

  return state;
}
